import { render, staticRenderFns } from "./fromGangnam.vue?vue&type=template&id=196f24bd&scoped=true&"
import script from "./fromGangnam.vue?vue&type=script&lang=js&"
export * from "./fromGangnam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196f24bd",
  null
  
)

export default component.exports